import React from 'react';
import NumberFormat from 'react-number-format';

import { useTranslation } from '../../hooks/useTranslation';
import TextField from '../text-field';
import { TextFieldProps } from '../text-field/TextField';

interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { value: string } }) => void;
}

const PhoneNumberFormat = (props: NumberFormatCustomProps | any) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      data-testid={'phone-input'}
      {...other}
      getInputRef={inputRef}
      onPaste={() => {
        window.getSelection()?.collapseToEnd();
      }}
      onValueChange={values => {
        if (values.value !== other.value) {
          onChange({
            target: {
              value: values.value,
              name: props.name,
            },
          });
        }
      }}
      type={'tel'}
      format="(###) ###-####"
      mask="_"
      allowNegative={false}
      thousandSeparator
      isNumericString
    />
  );
};

const PhoneTextField = React.forwardRef(
  (props: TextFieldProps | any, ref?: React.Ref<HTMLInputElement>) => {
    const { t } = useTranslation();
    return (
      <TextField
        label={props.label || t('PHONE_NUMBER')}
        onChange={props?.onChange}
        ref={ref}
        InputProps={{
          inputComponent: PhoneNumberFormat as any,
        }}
        inputRef={props.inputRef}
        name={props.name || 'phoneNumber'}
        margin={'normal'}
        style={props.style || { width: '100%' }}
        type={'tel'}
        {...props}
        defaultValue={props.defaultValue}
        variant={props.variant || null}
      />
    );
  },
);

export default PhoneTextField;
